<div fxLayout="column"
    fxLayoutAlign="start center">
    <div class="http-404">
        404
    </div>
    <div class="error-text">
        The page you requested could not be found
    </div>
</div>